export default {
  login_register: 'Login/Register',
  booking_confirmation_title: 'Potwierdzenie rezerwacji',
  booking_confirmation_body: 'Dziękujemy Ci za dokonanie rezerwacji. Szczegóły potwierdzenie znajdują się poniżej.',
  insurance_requirements_modal_disclaimer: `Dokonując tej rezerwacji, potwierdzam, że posiadam wszystkie niezbędne uprawnienia niezbedne do prowadzenia pojazdów. Proszę kliknąć {0} jeśli nie spełniasz tych wymagań`,
  location: 'Lokalizacja',
  pickup_location: 'Miejsce odbioru',
  dropoff_location: 'Miejsce zwrotu',
  vehicle: 'Pojazd',
  pickup_and_dropoff: 'Odbiór i zwrot (czas lokalny)',
  dropoff_location: 'Dropoff Location',
  distance_allowance: 'Limit odległości',
  view_voucher: 'Zobacz voucher',
  view_more_bookings: 'Zobacz więcej rezerwacji',
  identity_verification_body: 'Przed odbiorem pojazdu musisz potwierdzić swoją tożsamość',
  identity_verification_title: 'Potwierdź tożsamość',
  search_again: 'Wyszukaj ponownie',
  aircon_lower: 'aircon',
  aircon: 'klimatyzacja',
  refrigeration: 'Mrożony',
  not_available: 'Usługa Drive &amp; Go jest obecnie dostępna jedynie dla, których dokument tożsamości i prawo jazdy zostały wydane w: {profiles}, ale cały czas dodajemy kolejne kraje.  ',
  check_if_included: 'Sprawdź, czy Twój kraj znajduje się na tej liście.  ',
  included_in_booking: 'Niniejsza rezerwacja obejmuje',
  cdw_with_excess: 'Ubezpieczenie od kolizji (CDW) z udziałem własnym',
  theft_protection: 'Zabezpieczenie przed kradzieżą z udziałem własnym',
  risk_reduction: 'Ograniczenie ryzyka',
  free_extras: 'Z tą z tej rezerwacją masz prawo do dwóch  <br /> bezpłatnych dodatków.',
  continue: 'Kontynuuj',
  luggage_large_short_label: 'D',
  luggage_medium_short_label: 'Ś',
  luggage_small_short_label: 'M',
  luggage_large_long_label: 'duże',
  luggage_medium_long_label: 'średnie',
  luggage_small_long_label: 'małe',
  fuel_unspecified_label: 'dowolne ',
  transmission_manual_label: 'Ręczna',
  transmission_automatic_label: 'Automatyczna',
  make_a_booking: 'Dokonaj rezerwacji',
  pickup_date: 'Data odbioru',
  dropoff_date: 'Data zwrotu',
  driver_age: 'Kierowca w wieku 30 - 65 lat',
  enter_driver_age: 'Podaj wiek kierowcy',
  promo_code: 'Kod promocyjny',
  search: 'Wyszukaj',
  dropoff_date_cannot_be_before_pickup_date: 'Data zwrotu nie może być wcześniejsza od daty odbioru',
  pickup_date_cannot_be_in_the_past: 'Data odbioru nie może przypadać w przeszłości',
  pickup_time_cannot_be_in_the_past: 'Godzina odbioru nie może przypadać w przeszłości',
  dropoff_time_must_be_later_than_the_pickup_time_if_on_the_same_day: 'Godzina zwrotu musi być późniejsza niż godzina odbioru, jeśli przypadają w tym samym dniu',
  vehicle_filters: 'Filtry dotyczące pojazdu',
  reset: 'Zresetuj',
  transmission: 'Skrzynia biegów',
  all: 'Wszystkie',
  manual: 'Ręczna',
  auto: 'Automatyczna',
  passengers: 'Pasażerowie',
  vehicle_type: 'Typ pojazdu',
  filter: 'Rodzaj pojazdu',
  vehicle_search: 'Filtr',
  edit: 'Edytuj',
  no_results: 'Brak wyników odpowiadającym Twoim kryteriom wyszukiwania.',
  small_cars: 'Małe samochody',
  medium_cars: 'Średnie samochody',
  large_cars: 'Duże samochody',
  estate_cars: 'Samochody kombi',
  suvs: 'SUVy',
  mpvs: 'Minivany (MVP)',
  vans: 'Samochody dostawcze',
  camper_vans: 'Samochody kempingowe',
  premium: 'Samochody klasy premium',
  unspecified: 'dowolne ',
  large: 'duże',
  medium: 'średnie',
  small: 'małe',
  automatic: 'automatyczne',
  you_have_been_refunded: 'Zwrócono Ci pieniądze',
  please_customer_service: 'Aby dokonać rezerwacji, skontaktuj się z naszą Obsługi klienta.',
  contact_customer_service: 'Skontaktuj się z Obsługą Klienta',
  booking_failed: 'W tym momencie nie można było przetworzyć Twojej rezerwacji.',
  summary: 'Podsumowanie',
  reforestation_and_protection: 'Wesprzyj zalesianie oraz ochronę lasów tropikalnych w całej Kostaryce',
  cost_of_rental: 'Koszt wynajmu',
  to_pay_now: 'Zapłata teraz ',
  pay_on_arrival: 'Zapłata w momencie przyjazdu',
  greenheart_donation: 'Darowizna „Zielone serce”',
  tc_agreement: 'Przeczytałem i zrozumiałem {0}',
  tc: 'Zasady i Warunki',
  receive_offers: 'Chcę otrzymywać oferty specjalne drogą e-mailową.',
  donate: 'Tak, chcę przekazać darowiznę {amount}',
  pay_now: 'Zapłać teraz {amount}',
  driver_details: 'Dane kierowcy',
  complete_driver_details: 'Uzupełnij dane kierowcy.',
  are_you_the_driver: 'Czy jesteś kierowcą?',
  have_an_account: 'Czy masz już konto?',
  login: 'Login',
  or: 'lub',
  first_name: 'Imię kierowcy',
  last_name: 'Nazwisko kierowcy',
  email: 'Adres e-mail',
  phone_number: 'Numer telefonu komórkowego',
  unable_to_save_driver_information: 'Nie można zapisać informacji o kierowcy. Spróbuj ponownie.',
  pay_online_now: 'Zapłata teraz przez Internet',
  day: 'Dzień',
  choose_location: 'Wybierz lokalizację',
  location_not_found: 'Przykro nam, nie znaleźliśmy szukanej przez Ciebie lokalizacji.',
  add: 'Dodaj',
  remove: 'Usuń',
  free_extra: 'Bezpłatny dodatek',
  free: 'BEZPŁATNIE!',
  fast_track_notice: 'W przypadku tej usługi mają zastosowanie ograniczenia dotyczące pochodzenia dokumentów. Jest ona dostępna jedynie dla osób z dokumentami z następujących krajów',
  complete_booking: 'Dokończ rezerwację',
  choose_card: 'Wybierz kartę lub dodaj nową.',
  add_billing_details: 'Dodaj informacje o płatności',
  card_number: 'Numer karty',
  card_holder_name: 'Imię i nazwisko właściciela karty',
  card_exp: 'MM / RR',
  card_cvc: 'CVC',
  save_card: 'Zapamiętać kartę?',
  amount_charged: 'Twoja karta zostanie zmieniona',
  payment_confirmation: 'Potwierdź rezerwację i płatność',
  payment_methods: 'dostępne metody płatności',
  use_saved_card: 'x użyj zapamiętanej karty',
  use_different_card: '+ użyj nowej karty',
  book_now: 'Zarezerwuj teraz ',
  minimum_age: 'Tylko w wieku ponad {age}',
  excess_liability: 'Ubezpieczenie udziału własnego',
  security_deposit: 'Kaucja zabezpieczająca',
  fuel_policy: 'Zasady dotyczące paliwa',
  like_for_like: 'Podobny poziom',
  full_to_full: 'Pełny bak',
  miles_per_rental: '{mileage} bezpłatne mile podczas wypożyczenia',
  km_per_rental: '{mileage} bezpłatne kilometry podczas wypożyczenia',
  unlimited_mileage: 'Nieograniczony przebieg',
  unlimited_mileage_km: 'Bez limitu kilometrów',
  non_amendable: 'Nie podlega modyfikacji',
  non_refundable: 'Nie podlega zwrotowi',
  free_cancellation_until: 'Bezpłatne anulowanie przed',
  cancellation_in_line_with: 'Anulowanie zgodnie z',
  tcs: 'Regulaminem',
  free_extras_on_collection: 'Dwa bezpłatne dodatki przy odbiorze',
  glass_and_tyres_covered: 'Obejmuje szyby i opony',
  number_of_passengers: 'Liczba pasażerów',
  number_of_bags: 'Liczba poduszek',
  fuel_type: 'Rodzaj paliwa',
  co2: 'CO2',
  book_type: 'Zarezerwuj  {type}',
  processing: 'Przetwarzanie',
  actual_price: 'Rzeczywista cena  ',
  tooltip: 'Cena podana w $ {currencyCode} jest oszacowana na podstawie kursu wymiany walut, cena podana w $ {currency} jest wiążąca. ',
  deposit: 'Kaucja',
  pay_online: 'Płatność teraz przez Internet',
  pay_online_without_extras: 'Nadmiar odpowiedzialności  Depozyt zabezpieczający  Polityka paliwowa  Like for like  Full Full   Darmowe mile na wynajem   Darmowy km na wynajem  Nieograniczona  Nieograniczony przebieg  Nieograniczona  Nie podlega nowelizacji  Nie podlegają zwrotowi.  Darmowe anulowanie rezerwacji aż do  Anulacja w zgodzie z  T  Dwa bezpłatne dodatki w kolekcji  Szkło i opony objęte  Liczba pasażerów  Liczba worków  Typ paliwa  CO2  Klim  booki   Przetwarzanie  Rzeczywista cena  Cena w $ jest oszacowanie w oparciu o kurs wymiany walut, ceny w $ jest wiążąca. ',
  extras_on_arrival: 'Dodatki w momencie przyjazdu.',
  insurance_on_arrival: 'Ograniczenie ryzyka - płatność w momencie przyjazdu',
  insurance_online: 'Ograniczenie ryzyka - płatność teraz',
  extras_online: 'Dodatki - płatność teraz',
  green_heart_donation: 'Darowizna na „Zielone serce”',
  why_use_drive_and_go: 'Dlaczego warto skorzystać z Drive & Go?',
  straight_to_car: 'Bezpośredni odbiór samochodu',
  no_queues: 'Brak kolejek',
  self_checkout: 'Samodzielny odbiór',
  cant_lose_key: 'Brak ryzyka utraty kluczyka',
  online_id_check: 'Weryfikacja tożsamości online',
  phone_as_key: 'Telefon jako klucz',
  premiumplus_benefits_includes: 'Zawiera korzyści programu Premium Plus+',
  book_drive_go: 'Zarezerwuj Drive & Go',
  duration: 'Czas wypożyczenia',
  to_pay_on_arrival: 'Zapłata w momencie przyjazdu',
  return_date: 'Data zwrotu',
  additional_options: 'Dodatkowe opcje',
  booking_details: 'Dane rezerwacji',
  price_for_x_days: 'Cena za {qty_of_days} dzień | Cena za {qty_of_days} dni',
  cancelled: 'Anulowano',
  upcoming: 'Nadchodzące',
  active: 'AKTYWNE REZERWACJE',
  drive_and_go: {
    drive_and_go: 'Drive & Go',
    available_countries: 'Usługa Drive &amp; Go jest obecnie dostępna tylko dla osób, których dokument tożsamości i prawo jazdy wydano w następujących krajach:  ',
    drive_and_go_today: 'Już dziś zarezerwuj usługę Drive & Go!',
    drive_and_go_shortened: 'Drive & Go',
    why_use_drive_and_go: 'Dlaczego warto skorzystać z Drive & Go?',
    straight_to_car: 'Bezpośredni odbiór samochodu',
    no_queues: 'Brak kolejek',
    self_checkout: 'Samodzielny odbiór',
    cannot_lose_the_key: 'Brak ryzyka utraty kluczyka',
    online_id_check: 'Weryfikacja tożsamości online',
    phone_as_a_key: 'Telefon jako klucz',
    premium_plus_benefits_also_included: 'Zawiera korzyści programu Premium Plus+',
    book_drive_and_go: 'Zarezerwuj Drive & Go'
  },
  my_bookings: "Moje rezerwacje",
  no_bookings: "Brak rezerwacji",
  my_profile: 'Mój profil',
  no_bookings_to_display: 'Brak rezerwacji do wyświetlenia.',
  search_great_car_rental_deals: "Wyszukaj świetne oferty wynajmu samochodów na następną podróż.",
  odometer_at_collection: 'Stan licznika przy odbiorze',
  fuel_at_collection: 'Poziom paliwa przy odbiorze',
  start_check_in: 'Rozpocznij check-in',
  start_collection: 'Rozpocznij odbiór',
  recent_bookings: 'Niedawne rezerwacje',
  damage: {
    updated_damage_report_submitted: 'Przedstawiono zaktualizowany raport o uszkodzeniu. W razie potrzeby skontaktuje się z Tobą nasz zespół Obsługi Klienta.',
    add_additional_damage: 'Dodaj dodatkowe uszkodzenie',
    you_may_report_additional_damage_up_to: 'Możesz zgłosić dodatkowe uszkodzenia w trakcie odbioru pojazdu',
    specify_damage: 'Określ rodzaj uszkodzenia',
    please_choose_the_area_and_type_of_damage: 'Wybierz miejsce i rodzaj uszkodzenia',
    type_of_damage: 'Rodzaj uszkodzenia',
    is_this_more_than_5_cm: 'Czy to więcej niż 5 cm?',
    please_take_or_select_a_photo: 'Zrób lub wybierz zdjęcie',
    please_take_a_photo_ensuring_the_damage_is_clearly_visible: 'Wykonaj zdjęcie, upewniając się, że uszkodzenie jest wyraźnie widoczne',
    if_you_require_you_may_add_another_photo_select_the_icon_to_add_another_photo: ' W razie potrzeby możesz dodać kolejne zdjęcie, wybierz ikonę, aby dodać kolejne zdjęcie',
    save_image: 'Zapisz obraz',
    save_images: 'Zapisz obrazy',
    damage_saved_successfully: 'Uszkodzenie zapisane',
    add_photo: 'Dodaj zdjęcie'
  },
  checkout: {
    start_collection: 'Rozpocznij odbiór',
    collect_vehicle: 'Odbierz pojazd',
    we_will_let_you_know_the_details: 'Poinformujemy cię o lokalizacji i szczegółach, aby móc zlokalizować wynajmowany pojazd.',
    inspect: 'Dokonaj kontroli',
    we_will_ask_for_four_photos_from_each_corner: 'Poprosimy cię o zrobienie czterech zdjęć przy każdym narożniku pojazdu i uwzględnienie jeszcze niewymienionych uszkodzeń.',
    fuel_and_milage: 'Paliwo i przebieg',
    you_confirm_the_readings_at_the_start_of_your_hire: 'Na początku wypożyczenia należy potwierdzić stan licznika i odczyt paliwa.',
    sign: 'Podpisz',
    sign_the_rental_agreement: 'Podpisz umowę najmu.',
    away_you_go: 'I w drogę',
    you_are_free_to_take_to_the_road: 'Pora ruszać w trasę!',
    collect_your_vehicle: 'Odbierz swój pojazd',
    get_directions: 'Uzyskaj trasę',
    hide_directions: 'Ukryj trasę',
    local_time: 'czas lokalny',
    tel: 'Tel',
    getting_to_the_location: 'Jak dotrzeć na miejsce',
    get_vehicle_details: 'Uzyskaj dane o pojeździe',
    view_map: 'Zobacz mapę',
    unlock_vehicle_and_continue: 'Odblokuj pojazd i kontynuuj',
    unable_to_connect_to_vehicle: 'Nie można połączyć z pojazdem',
    we_were_unable_to_connect_to_the_vehicle_please_check: 'Nie byliśmy w stanie połączyć się z pojazdem – sprawdź, czy znajdujesz się obok właściwego pojazdu, i spróbuj ponownie.',
    we_were_unable_to_find_the_vehicle_booking_please_try_again_later: 'Nie znaleźliśmy rezerwacji pojazdu. Spróbuj ponownie później.',
    odometer_and_fuel: 'Stan licznika i paliwa',
    odometer: 'Stan licznika',
    please_confirm_the_odometer_and_fuel_readings: 'Potwierdź stan licznika i odczyt paliwa.',
    the_odometer_field_is_required: 'Pole stanu licznika jest wymagane',
    and_must_be_greater_than_the_checkout_odometer: 'i musi wynosić więcej zdaniu pojazdu',
    confirm: 'Potwierdź',
    please_take_a_photo_from_each_corner_of_the_vehicle: 'Zrób zdjęcie przy każdym narożniku pojazdu',
    pre_existing_damage: 'Wcześniejsze uszkodzenia',
    no_pre_existing_damage: 'Brak wcześniejszych uszkodzeń.',
    new_damage: 'Nowe uszkodzenie',
    add_additional_damage: 'dodaj dodatkowe uszkodzenie',
    no_new_damage_to_report: 'Brak nowych uszkodzeń',
    checkout_complete: 'Odbiór ukończony',
    start_rental: 'Rozpocznij wypożyczenie',
    congratulations_name_it_is_time_to_take_to_the_road: 'Gratulacje, {customer_name}, pora ruszać w trasę!',
    we_are_unable_to_complete_your_vehicle_checkout: 'Nie można ukończyć procedury zdania pojazdu.',
    please_do_the_following: 'Wykonaj następujące czynności',
    remove_all_belonging_and_lock_the_vehicle: 'Zabierz wszystkie rzeczy i zablokuj pojazd.',
    lock_vehicle: 'Zablokuj pojazd',
    once_you_have_contacted_customer_services: 'Po kontakcie z Obsługą Klienta',
    vehicle_location: 'Lokalizacja pojazdu',
    collect_your: 'Odbierz swój',
    from: 'Od',
    key_in_glove_box: 'Twój klucz znajduje się w schowku',

    keyholder: {
      not_detected: 'Klucz nie został wykryty w breloku',
      not_detected_please_try_again: 'Umieść klucz w breloku, a następnie spróbuj ponownie.',

      not_installed: 'Brelok nie został zainstalowany',
      not_installed_please_contact_customer_service: 'Brelok nie został zainstalowany, skontaktuj się z obsługą klienta.',
    },
    keyring: {
      look_up_failed: 'Wyszukiwanie kluczy nie powiodło się',
      look_up_failed_please_contact_customer_service: 'Brelok nie sprawdził się, skontaktuj się z obsługą klienta.',
    },
    key: {
      invalid: 'Klucz jest nieprawidłowy',
      invalid_please_contact_customer_service: 'Twój klucz jest nieprawidłowy, skontaktuj się z obsługą klienta.',

      expired: 'Klucz wygasł',
      expired__please_contact_customer_service: 'Twój klucz wygasł, skontaktuj się z obsługą klienta.',
    }
  },
  checkin: {
    tell_us_where_you_have_parked: 'Przekaż nam, gdzie został zaparkowany pojazd.',
    vehicle_location: 'Vehicle Location',
    tell_us_where_you_have_parked: 'Tell us where you\'ve parked the vehicle.',
    fuel_and_milage: 'Paliwo i stan licznika',
    you_confirm_the_readings_at_the_end_of_your_hire: 'Na koniec wypożyczenia należy potwierdzić stan licznika i odczyt paliwa.',
    inspect: 'Dokonaj kontroli',
    we_will_as_for_four_photos_from_each_corner_of_the_vehicle_along_with_any_new_damage: 'Poprosimy cię o zrobienie czterech zdjęć przy każdym narożniku pojazdu i uwzględnienie uszkodzeń powstałych w trakcie wypożyczenia.',
    lock: 'Zablokuj',
    check_you_have_left_no_belonging_then_lock_the_vehicle: 'Sprawdź, czy w pojeździe nie zostały żadne rzeczy, a następnie zablokuj pojazd.',
    please_tell_us_where_you_have_parked_the_vehicle: 'Przekaż nam, gdzie został zaparkowany pojazd',
    once_the_vehicle_is_locked_you_will_be_unable_to_unlock_it_again: 'Po zablokowaniu pojazdu nie będzie go można ponownie otworzyć.',
    name_please_check_you_have_left_no_belongings_then_lock_the_vehicle: '{first_name}, sprawdź, czy nie zostawiłeś żadnych rzeczy, zamknij pojazd i, jeśli to konieczne, zwróć klucz fizyczny do breloka.',
    lock_vehicle: 'Zablokuj pojazd',
    complete_check_in: 'Ukończ check-in',
    inspection: 'Kontrola',
    complete_vehicle_check_in: 'Ukończ check-in pojazdu',
    we_are_unable_to_complete_your_vehicle_check_in: 'Nie można procedury odbioru pojazdu.',
    please_contact_customer_services: 'Prosimy o kontakt z Obsługą Klienta',
    once_you_have_contacted_customer_services: 'Once you\'ve contacted customer services',
    once_you_have_contacted_customer_services: 'Po kontakcie z Obsługą Klienta'
  },
  rental_agreement: {
    rental_agreement: 'Umowa najmu',
    agreement_between: 'Umowa między',
    and: 'i',
    sign_rental_agreement: 'Podpisz umowę najmu',
    i_have_read_and_understood_the_terms_and_conditions: 'Przeczytałem i zrozumiałem Zasady i Warunki i akceptuję stan pojazdu'
  },
  additional_options: 'Dodatkowe opcje',
  booking_details: 'Szczegóły rezerwacji',
  price_for_x_days: 'Cena za {qty_of_days} dzień | Cena za {qty_of_days} dni',
  cancelled: 'Anulowany',
  upcoming: 'Nadchodzący',
  active: 'Aktywny',
  full_insurance_no_deposit: 'Pełne ubezpieczenie i bez depozytu',
  excess: '{amount} udział własny',
  deposit: '{amount} depozyt',
  included_daily_distance: '{distance} {unit} dziennie',
  miles: 'mil',
  kilometers: 'kilometrów',
  collection_details_title: 'Szczegóły kolekcji',
  collection_details_not_found: 'Brak zdefiniowanych szczegółów kolekcji dla tej lokalizacji',
  free_cancellation: 'Darmowa rezygnacja',
  no_deposit: 'Bez depozytu',
  benefit_from: 'Czerpać korzyść z',
  for_only_per_day: 'Tylko dla {price} cenie dziennie',
  upgrade_mee: 'UpgradeMee'
}



// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/lang/pl/bookings.js